import { GetStaticPaths, GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Search from "components/transporter/search/Search";
import { TRANSPORT_DIRECTORY_ISR_REVALIDATE_SECONDS } from "../../constants/marketplace.constants";
import { TRANSPORT_DIRECTORY } from "../../constants/route-constants";
import { getRouteLocalizationNamespaces } from "../../methods/getRouteLocalizationNamespaces";

const { i18n } = require("../../next-i18next.config");

function buildTransporterStaticPaths() {
    const locales: string[] = i18n.locales;

    return locales.map((locale) => ({
        params: { params: [] as string[] },
        locale
    }));
}

export default function TransporterSearch() {
    return <Search route={TRANSPORT_DIRECTORY} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
    return {
        paths: buildTransporterStaticPaths(),
        fallback: "blocking"
    };
};

export const getStaticProps: GetStaticProps = async (context) => {
    return {
        props: {
            ...(await serverSideTranslations(context.locale!, getRouteLocalizationNamespaces(TRANSPORT_DIRECTORY))),
            route: TRANSPORT_DIRECTORY
        },
        revalidate: TRANSPORT_DIRECTORY_ISR_REVALIDATE_SECONDS
    };
};
